import { render, staticRenderFns } from "./DocArticle.vue?vue&type=template&id=02573f68&"
import script from "./DocArticle.vue?vue&type=script&lang=js&"
export * from "./DocArticle.vue?vue&type=script&lang=js&"
import style0 from "./DocArticle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports